import React from 'react';

export const patientSettingsConfig = [
  {
    auth: ['user'],
    routes: [
      {
        path: '/settings',
        component: React.lazy(() => import('./SettingsTabs')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/phone-input',
        component: React.lazy(() => import('./phoneInput')),
      },
    ],
  },
  {
    auth: ['user'],
    routes: [
      {
        path: '/capacity-competency',
        component: React.lazy(() => import('./CapacityCompetency')),
      },
    ],
  }
];